/* eslint-disable prettier/prettier */
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

type NavItemProps = {
  to?: string;
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
};

export const NavItem = ({ to, label, icon, onClick }: NavItemProps) => {
  const baseClass = 'flex items-center space-x-3 text-lg font-semibold px-9 py-4 transition';
  if (to) {
    return (
      <NavLink
        to={to}
        className={({ isActive }) =>
          `${baseClass} ${
            isActive ? 'bg-primary text-muted' : 'hover:bg-secondary hover:text-highlight'
          }`
        }
      >
        {icon && <span className='mb-[2px]'>{icon}</span>}
        <span>{label}</span>
      </NavLink>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`${baseClass} hover:bg-secondary hover:text-highlight w-full`}
    >
      {icon && <span>{icon}</span>}
      <span>{label}</span>
    </button>
  );
};
